import React, { FunctionComponent } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import clsx from 'clsx'
import { hexToRgbaCss } from 'core/utils/colorHelpers'

interface Props {
  overflow?: boolean
  fill?: boolean
  className?: any
  children: any
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  pre: {
    padding: '6px 10px',
    margin: 0,
    fontFamily: 'SpaceMono',
    fontWeight: 'normal',
    borderRadius: 4,
    display: 'inline-block',
    backgroundColor: theme.components.code.background,
    color: theme.components.code.text,
    wordBreak: 'break-all',
    whiteSpace: 'pre-wrap',
    maxHeight: 400,
    overflow: 'auto',
    flexGrow: 0,

    '& *': {
      fontFamily: 'SpaceMono',
    },
  },
  preFill: {
    display: 'flex',
    maxHeight: 'initial',
    flexGrow: 1,
  },
  preOverflow: {
    whiteSpace: 'pre',
  },
}))

const CodeBlock: FunctionComponent<Props> = ({
  overflow = false,
  children,
  className,
  fill = false,
}) => {
  const styles = useStyles()
  return (
    <pre
      className={clsx(
        styles.pre,
        { [styles.preFill]: fill, [styles.preOverflow]: overflow },
        'thin-scrollbar',
        className,
      )}
    >
      <code>{children}</code>
    </pre>
  )
}

export default CodeBlock
